const base_URL = "https://www.breakingbadapi.com/api"

export default base_URL